import { render, staticRenderFns } from "./NeuralNew.vue?vue&type=template&id=213f7878&scoped=true&"
import script from "./NeuralNew.vue?vue&type=script&lang=js&"
export * from "./NeuralNew.vue?vue&type=script&lang=js&"
import style0 from "./NeuralNew.vue?vue&type=style&index=0&id=213f7878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f7878",
  null
  
)

export default component.exports